<template>
  <div class="pageTop">
    <LoginPageTitle title-text="ログイン" />
    <TextLink
      arrow-type="rightArrowRight"
      link-url="/smp2/quipMember/register/infoInput/"
      link-text="新規会員登録"
      class="newRegistration"
      @onClick="onClick($event)"
    />
  </div>
</template>

<script>
import LoginPageTitle from '../common/Text/LoginPageTitle.vue';
import TextLink from '../../../common/common/Button/TextLink.vue';
import { sendLog } from '../../../../helper/_sendLog';

export default {
  name: 'PageTop',
  components: {
    LoginPageTitle,
    TextLink,
  },
  methods: {
    onClick(event) {
      sendLog(s, event.target, `${trace_p}_up_signup`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

.pageTop {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.newRegistration {
  font-size: 14px;
}
</style>
